// import React from 'react';
// import { Card, Skeleton } from '@mui/material';
// // import WeekendIcon from '@mui/icons-material/Weekend';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';

// // const formatDuration = (minutes) => {
// //   if (minutes >= 60) {
// //     return {
// //       value: (minutes / 60).toFixed(2),
// //       unit: 'hr Avg.'
// //     };
// //   }
// //   return {
// //     value: Number(minutes).toFixed(2),
// //     unit: 'min Avg.'
// //   };
// // };

// const StatItem = ({ label, counts, loading }) => {
//   return (
//     <div className="bg-white rounded p-3 mb-2">
//       {loading ? (
//         <>
//           <Skeleton variant="text" width="60%" height={24} />
//           <Skeleton variant="text" width="40%" height={20} />
//         </>
//       ) : (
//         <div className="flex flex-col">
//           <div className="flex items-baseline gap-1">
//             <span className="text-xl font-medium">{counts}</span>
//           </div>
//           <div className="text-sm text-gray-500">{label}</div>
//         </div>
//       )}
//     </div>
//   );
// };

// // const BreakItem = ({ breakNumber, count, dwellTime, loading }) => {
// //   const formatted = formatDuration(dwellTime);
// //   return (
// //     <div className="bg-white rounded p-2 mb-2 text-sm shadow-sm">
// //       {loading ? (
// //         <>
// //           <Skeleton variant="text" width="60%" height={24} />
// //           <Skeleton variant="text" width="40%" height={20} />
// //           <Skeleton variant="text" width="30%" height={20} />
// //         </>
// //       ) : (
// //         <div className="flex items-start gap-2">
// //           <FiberManualRecordIcon
// //             sx={{
// //               color: dwellTime > 2 ? '#ef4444' : '#22c55e',
// //               fontSize: '12px',
// //               marginTop: '4px'
// //             }}
// //           />
// //           <div>
// //             <div className="font-bold">Break {breakNumber}</div>
// //             <div className="text-xs text-gray-500">Count: {count} people</div>
// //             <div className="text-xs text-gray-500">
// //               Duration: {formatted.value} {formatted.unit}
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// const RestAreaCard = ({ data, loading }) => {
//   // const averageDwellTime = data?.[0]?.average_dwell_time || 0;
//   // const totalCount = data?.[0]?.total_count || 0;
//   // const breaks = data?.[0]?.labels || [];
//   // const formattedDwellTime = formatDuration(averageDwellTime);
//   const idleTimeDate = data?.idleManPower[0];
//   console.log('idleTimeDate', idleTimeDate);

//   return (
//     <div>
//       <Card
//         className="border relative border-gray-300"
//         sx={{
//           height: '276px',
//           boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
//           borderRadius: '8px'
//         }}
//       >
//         <div className="flex w-full flex-col gap-1 p-3">
//           <div className="flex items-center gap-2">
//             <AccessTimeIcon className="text-white rounded-full p-2 text-6xl" style={{ backgroundColor: '#ffa000' }} />
//             <div style={{ width: loading ? '120px' : 'auto' }}>
//               {loading ? (
//                 <>
//                   <Skeleton variant="text" width="100%" height={40} />
//                   <Skeleton variant="text" width="80%" height={28} />
//                 </>
//               ) : (
//                 <>
//                   <div className="flex items-baseline gap-1">
//                     {/* <div>
//                       <span className="text-3xl font-medium">{formattedDwellTime.value}</span>
//                       <span className="text-sm text-gray-500 ml-1">{formattedDwellTime.unit}</span>
//                     </div> */}
//                     {/* <div className="border-l pl-1">
//                       <span className="text-xl font-medium">{totalCount}</span>
//                       <span className="text-sm text-gray-500 ml-1">visits</span>
//                     </div> */}
//                   </div>
//                   <p className="text-lg font-semibold">Truck Count</p>
//                 </>
//               )}
//             </div>
//           </div>
//           <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
//             <div className="text-xs text-gray-500 mb-2 italic">More Statistics</div>
//             <StatItem
//               label={
//                 <>
//                   <span className="text-2xl font-semibold text-black">
//                     {idleTimeDate?.total_entry_trucks ? idleTimeDate?.total_entry_trucks : 0}
//                   </span>
//                   <br />
//                   <span className="text-sm text-gray-500">Entry</span>
//                 </>
//               }
//             />
//             <StatItem
//               label={
//                 <>
//                   <span className="text-2xl font-semibold text-black">
//                     {idleTimeDate?.total_exit_trucks ? idleTimeDate?.total_exit_trucks : 0}
//                   </span>
//                   <br />
//                   <span className="text-sm text-gray-500">Exit</span>
//                 </>
//               }
//             />
//           </div>
//         </div>
//       </Card>
//     </div>
//   );
// };

// export default RestAreaCard;


import React from 'react';

// /* --- constants so you can tweak one place --- */
// const cardWidth = 416;          // match MHE width
// const cardHeight = 287;         // match MHE height
// const headerPillWidth = 368;    // match MHE pill width

/* ---------- Provided STATISTICS icons (24x24) ---------- */
const EntrySVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
    style={{ width: 24, height: 24, flexShrink: 0, aspectRatio: '1 / 1' }}>
    <path d="M10.1719 1.31708V22.6829L16.8281 20.6862V3.31391L10.1719 1.31708ZM17.669 2.57708L17.6719 2.68616V4.07811H18.4219V2.57811L17.669 2.57708ZM5.57812 2.57811V8.07514H6.42188V3.42186H9.32812V2.57811H5.57812ZM17.6719 4.92186V5.67186H18.4219V4.92186H17.6719ZM17.6719 6.51561V17.5781H18.4219V6.51561H17.6719ZM6.42188 9.26844V10.9219H1.92188V13.0781H6.42188V14.7315L9.15342 12L6.42188 9.26844ZM11.4375 10.875C11.7481 10.875 12 11.3787 12 12C12 12.6213 11.7481 13.125 11.4375 13.125C11.1269 13.125 10.875 12.6213 10.875 12C10.875 11.3787 11.1269 10.875 11.4375 10.875ZM6.42188 15.9248H5.57812V21H6.42188V15.9248ZM17.6719 18.4219V19.0781H18.4219V18.4219H17.6719ZM17.6719 19.9219V21H18.4219V19.9219H17.6719ZM1.5 22.0781V22.9219H9.32812V22.0781H1.5ZM15.1243 22.0781L12.3118 22.9219H22.5V22.0781H15.1243Z" fill="#2EB67D"/>
  </svg>
);

const ExitSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
    style={{ width: 24, height: 24, flexShrink: 0, aspectRatio: '1 / 1' }}>
    <path d="M10.1719 1.31708V22.6829L16.8281 20.6862V3.31391L10.1719 1.31708ZM17.669 2.57708L17.6719 2.68616V4.07811H18.4219V2.57811L17.669 2.57708ZM5.57812 2.57811V8.07514H6.42188V3.42186H9.32812V2.57811H5.57812ZM17.6719 4.92186V5.67186H18.4219V4.92186H17.6719ZM17.6719 6.51561V17.5781H18.4219V6.51561H17.6719ZM11.4375 10.875C11.7481 10.875 12 11.3787 12 12C12 12.6213 11.7481 13.125 11.4375 13.125C11.1269 13.125 10.875 12.6213 10.875 12C10.875 11.3787 11.1269 10.875 11.4375 10.875ZM6.42188 15.9248H5.57812V21H6.42188V15.9248ZM17.6719 18.4219V19.0781H18.4219V18.4219H17.6719ZM17.6719 19.9219V21H18.4219V19.9219H17.6719ZM1.5 22.0781V22.9219H9.32812V22.0781H1.5ZM15.1243 22.0781L12.3118 22.9219H22.5V22.0781H15.1243Z" fill="#2EB67D"/>
    <path d="M4.73145 9V10.6534H9.23145V12.8097H4.73145V14.4631L1.9999 11.7315L4.73145 9Z" fill="#2EB67D"/>
  </svg>
);

/* ---------- Create a custom truck icon (52x52) for header ---------- */
const TruckHeaderSVG = ({ size = 52 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 52 52"
    fill="none"
    style={{ width: 52, height: 52, flexShrink: 0, aspectRatio: '1 / 1' }}
  >
    <path d="M8.6665 45.5C6.86095 45.5 5.32623 44.8681 4.06234 43.6042C2.79845 42.3403 2.1665 40.8056 2.1665 39C2.1665 38.0611 2.34706 37.1678 2.70817 36.3199C3.06928 35.472 3.61095 34.7404 4.33317 34.125V26C4.33317 25.3861 4.54117 24.8719 4.95717 24.4574C5.37317 24.0428 5.88739 23.8348 6.49984 23.8334H8.6665V13C8.6665 12.3861 8.8745 11.8719 9.2905 11.4574C9.7065 11.0428 10.2207 10.8348 10.8332 10.8334H23.129C23.9957 10.8334 24.7901 11.0681 25.5123 11.5375C26.2346 12.007 26.7762 12.657 27.1373 13.4875L36.1832 34.8292C36.3998 35.3348 36.5623 35.8403 36.6707 36.3459C36.779 36.8514 36.8332 37.375 36.8332 37.9167C36.8332 40.0111 36.0929 41.7986 34.6123 43.2792C33.1318 44.7598 31.3443 45.5 29.2498 45.5C27.7693 45.5 26.4057 45.1122 25.1592 44.3365C23.9126 43.5609 22.9838 42.5043 22.3728 41.1667H14.7895C14.3201 42.4667 13.5256 43.5139 12.4062 44.3084C11.2867 45.1028 10.0402 45.5 8.6665 45.5ZM47.6665 43.3334H41.1665C40.5526 43.3334 40.0384 43.1254 39.6238 42.7094C39.2093 42.2934 39.0013 41.7791 38.9998 41.1667V10.8334C38.9998 10.2195 39.2078 9.70525 39.6238 9.29069C40.0398 8.87614 40.5541 8.66814 41.1665 8.66669C41.7789 8.66525 42.2939 8.87325 42.7113 9.29069C43.1288 9.70814 43.3361 10.2224 43.3332 10.8334V39H47.6665C48.2804 39 48.7953 39.208 49.2113 39.624C49.6273 40.04 49.8346 40.5543 49.8332 41.1667C49.8317 41.7791 49.6237 42.2941 49.2092 42.7115C48.7946 43.129 48.2804 43.3363 47.6665 43.3334ZM8.6665 41.1667C9.28039 41.1667 9.79534 40.9587 10.2113 40.5427C10.6273 40.1267 10.8346 39.6125 10.8332 39C10.8317 38.3876 10.6237 37.8734 10.2092 37.4574C9.79462 37.0414 9.28039 36.8334 8.6665 36.8334C8.05262 36.8334 7.53839 37.0414 7.12384 37.4574C6.70928 37.8734 6.50128 38.3876 6.49984 39C6.49839 39.6125 6.70639 40.1274 7.12384 40.5449C7.54128 40.9623 8.0555 41.1696 8.6665 41.1667ZM29.2498 41.1667C30.1526 41.1667 30.9203 40.8511 31.553 40.2199C32.1857 39.5886 32.5013 38.8209 32.4998 37.9167C32.4984 37.0125 32.1828 36.2455 31.553 35.6157C30.9232 34.9859 30.1555 34.6696 29.2498 34.6667C28.3442 34.6638 27.5772 34.9801 26.9488 35.6157C26.3205 36.2513 26.0042 37.0183 25.9998 37.9167C25.9955 38.8151 26.3118 39.5829 26.9488 40.2199C27.5858 40.8569 28.3528 41.1725 29.2498 41.1667ZM19.3373 30.3334H29.5748L23.129 15.1667H12.9998V23.8334L19.3373 30.3334Z" fill="#2EB67D"/>
  </svg>
);

/* ---------- Small stat row (mobile responsive) ---------- */
const StatRow = ({ icon, value, label, isLast }) => (
  <div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 'clamp(8px, 2vw, 12px)', marginBottom: 10 }}>
      <div
        style={{
          width: 'clamp(32px, 5vw, 36px)',
          height: 'clamp(32px, 5vw, 36px)',
          borderRadius: '50%',
          background: 'rgba(86,129,255,0.18)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          outline: '1px solid rgba(86,129,255,0.35)',
          flexShrink: 0
        }}
      >
        {icon}
      </div>

      <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, minWidth: 0, flex: 1 }}>
        <span style={{ 
          fontSize: 'clamp(18px, 3.5vw, 22px)', 
          fontWeight: 800,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>{value}</span>
        <span style={{ 
          fontSize: 'clamp(11px, 2vw, 13px)', 
          color: 'rgba(226,232,240,0.7)',
          flexShrink: 0
        }}>{label}</span>
      </div>
    </div>

    {!isLast && <div style={{ margin: '14px 0', height: 1, backgroundColor: 'rgba(255,255,255,0.06)' }} />}
  </div>
);

/* ---------- Header pill (mobile responsive) ---------- */
const HeaderPill = ({ total }) => (
  <div
    style={{
      position: 'relative',
      width: '100%',
      height: 'clamp(90px, 12vw, 103px)',
      borderRadius: 18,
      padding: 'clamp(12px, 3vw, 20px)',
      display: 'flex',
      alignItems: 'center',
      color: '#fff',
      overflow: 'hidden',
      background: 'linear-gradient(180deg, rgba(20,31,74,0.9) 0%, rgba(12,18,48,0.9) 100%)',
      boxShadow: 'inset 0 0 0 1px rgba(86,129,255,0.55), 0 8px 22px rgba(0,0,0,0.35)'
    }}
  >
    {/* slanted overlay like MHE */}
    <div
      style={{
        position: 'absolute',
        right: '-20%',
        top: 0,
        bottom: 0,
        width: '70%',
        transform: 'skewX(-18deg)',
        background: 'linear-gradient(180deg, rgba(7,12,32,0.65) 0%, rgba(7,12,32,0.2) 100%)',
        filter: 'blur(0.2px)'
      }}
    />

    {/* Left: Title + count */}
    <div style={{ position: 'relative', zIndex: 2, flex: 1, minWidth: 0 }}>
      <div style={{ 
        fontSize: 'clamp(14px, 2.5vw, 16px)', 
        fontWeight: 600, 
        marginBottom: 6,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}>Truck Count</div>

      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, minWidth: 0 }}>
        <div style={{ 
          fontSize: 'clamp(28px, 6vw, 40px)', 
          fontWeight: 300, 
          lineHeight: 1,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>{total}</div>
        <div style={{ 
          fontSize: 'clamp(10px, 2vw, 12px)', 
          opacity: 0.8,
          flexShrink: 0
        }}>Total Trucks</div>
      </div>
    </div>

    {/* Right: responsive truck icon */}
    <div
      style={{
        position: 'absolute',
        right: 'clamp(12px, 3vw, 18px)',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 3,
        flexShrink: 0
      }}
    >
      <TruckHeaderSVG size={window.innerWidth < 480 ? 36 : 52} />
    </div>
  </div>
);

/* ---------- Skeleton (exact MHE style) ---------- */
const SkeletonLoader = () => (
  <>
    <div
      style={{
        width: '100%',
        height: 110,
        borderRadius: 18,
        background: 'linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.04))',
        outline: '1px solid rgba(120,153,255,0.15)',
        marginBottom: 24
      }}
    />
    <div style={{ width: '24%', height: 26, backgroundColor: 'rgba(255,255,255,0.10)', borderRadius: 6, marginBottom: 10 }} />
    <div style={{ width: '36%', height: 22, backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 6, marginBottom: 10 }} />
    <div style={{ width: '30%', height: 22, backgroundColor: 'rgba(255,255,255,0.08)', borderRadius: 6 }} />
  </>
);

/* ---------- Main component (mobile responsive) ---------- */
const RestAreaCard = ({ data = {}, loading = false, width = '100%', height = 'auto', maxWidth = '416px', maxHeight = '287px' }) => {
  const idleTimeDate = data?.idleManPower?.[0] || {};
  const entry = Number(idleTimeDate?.total_entry_trucks ?? 0);
  const exit = Number(idleTimeDate?.total_exit_trucks ?? 0);
  const total = entry + exit;

  return (
    <div
      style={{
        position: 'relative',
        width: width,
        height: height,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        minWidth: '280px',
        borderRadius: 20,
        background: 'linear-gradient(127deg, rgba(6,11,40,0.94) 19.41%, rgba(10,14,35,0.49) 76.65%)',
        backdropFilter: 'blur(60px)',
        WebkitBackdropFilter: 'blur(60px)',
        padding: 'clamp(16px, 4vw, 24px)',
        color: '#fff',
        overflow: 'hidden',
        boxShadow: '0 12px 28px rgba(0,0,0,0.45)',
        fontFamily:
          'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, "Helvetica Neue", Arial, "Noto Sans", "Apple Color Emoji", "Segoe UI Emoji"'
      }}
    >
      {loading ? (
        <SkeletonLoader />
      ) : (
        <>
          <HeaderPill total={total} />

          {/* STATISTICS */}
          <div style={{ marginTop: 'clamp(14px, 3vw, 18px)' }}>
            <div
              style={{
                fontSize: 'clamp(10px, 2vw, 12px)',
                letterSpacing: '1.4px',
                color: 'rgba(226,232,240,0.75)',
                marginBottom: 10
              }}
            >
              STATISTICS
            </div>

            <div
              style={{
                height: 'clamp(120px, 20vw, 140px)',
                overflowY: 'auto',
                paddingRight: 8,
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(255,255,255,0.3) rgba(255,255,255,0.08)'
              }}
            >
              <StatRow icon={<EntrySVG />} value={entry} label="Entry" />
              <StatRow icon={<ExitSVG />} value={exit} label="Exit" isLast />
            </div>
          </div>
        </>
      )}

      {/* soft radial glow */}
      <div
        style={{
          position: 'absolute',
          top: '-40%',
          right: '-20%',
          width: 360,
          height: 360,
          borderRadius: '50%',
          background: 'radial-gradient(closest-side, rgba(255,255,255,0.06), rgba(255,255,255,0))',
          pointerEvents: 'none',
          filter: 'blur(2px)'
        }}
      />
    </div>
  );
};

export default RestAreaCard;